import {
    useCallback,
    useEffect,
} from "preact/compat";

export const isTypingInInput = (event: KeyboardEvent): boolean => {
    const target = event.target as HTMLElement;
    return target.tagName === "INPUT" || target.tagName === "TEXTAREA" ||
        target.isContentEditable;
};

type KeyboardHandlerOptions = {
    onKeyDown: (event: KeyboardEvent) => void;
    onEscape?: () => void;
    onShowHelp?: () => void;
    disabled?: boolean;
};

export const useKeyboardHandler = (options: KeyboardHandlerOptions): void => {
    const handleKeyDown = useCallback(
        (event: KeyboardEvent) => {
            if (event.key === "Escape") {
                options.onEscape?.();
                return;
            }

            if (options.disabled) return;
            if (isTypingInInput(event)) return;

            if (event.key === "?" && event.shiftKey) {
                event.preventDefault();
                options.onShowHelp?.();
                return;
            }

            options.onKeyDown(event);
        },
        [options],
    );

    useEffect(() => {
        globalThis.addEventListener("keydown", handleKeyDown);
        return () => {
            globalThis.removeEventListener("keydown", handleKeyDown);
        };
    }, [handleKeyDown]);
};
